import { render, staticRenderFns } from "./OrderVersionsCompareModal.vue?vue&type=template&id=ef0ccaa0&scoped=true"
import script from "./OrderVersionsCompareModal.vue?vue&type=script&lang=js"
export * from "./OrderVersionsCompareModal.vue?vue&type=script&lang=js"
import style0 from "./OrderVersionsCompareModal.vue?vue&type=style&index=0&id=ef0ccaa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0ccaa0",
  null
  
)

export default component.exports